import React, { Fragment, useContext, useState } from 'react'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { makeStyles } from '@material-ui/core/styles';
import { NavbarContext } from './Navbar';
import jwt from 'jwt-decode'

//style
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        color: 'white',
        backgroundColor: ' #6777ef'
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    list: {
        width: 250,
    },
    sidebarMenu: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
}));

function Admin() {
    const { stateNavbar, dispatchNavbar } = useContext(NavbarContext)
    const classes = useStyles();

    const handleClick = (e, params) => {
        e.preventDefault();
        dispatchNavbar({
            type: 'PAGE',
            page: params
        })
        dispatchNavbar({
            type: 'DRAWER',
            left: false
        })
    }

    return (
        <Fragment>
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={
                    <ListSubheader component="div" id="nested-list-subheader">
                        Menu
                </ListSubheader>}
                className={classes.sidebarMenu}
            >
                {jwt(localStorage.getItem('token-helpdesk-umy')).is_umy ? (
                    <ListItem button onClick={(e) => { handleClick(e, "message") }}>
                        <ListItemIcon>
                            <MailOutlineIcon />
                        </ListItemIcon>
                        <ListItemText primary="Message" />
                    </ListItem>
                ) : <Fragment />}
                <ListItem button onClick={(e) => { handleClick(e, "profile") }}>
                    <ListItemIcon>
                        <AccountCircleIcon />
                    </ListItemIcon>
                    <ListItemText primary="Profile" />
                </ListItem>
                <ListItem button onClick={(e) => { handleClick(e, "logout") }}>
                    <ListItemIcon>
                        <ExitToAppRoundedIcon />
                    </ListItemIcon>
                    <ListItemText primary="Logout" />
                </ListItem>
            </List>
        </Fragment>
    )
}

export default Admin
